import { resources } from '../content';
import { endpoints } from '../config';

/** §4.1 Resources: help centre, knowledge, release notes, API documentation, security and status. */
export default function Resources() {
  return (
    <>
      <section className="section">
        <div className="wrap">
          <div className="section__head">
            <span className="eyebrow">Resources</span>
            <h1 style={{ marginBottom: 16 }}>Documentation, and how to reach a person</h1>
            <p>
              Everything needed to set ClientMa up, connect it to something else, and understand
              what it does with your data.
            </p>
          </div>

          <div className="grid grid--3">
            {resources.map((resource) => (
              <article key={resource.title} className="card">
                <h3>{resource.title}</h3>
                <p>{resource.body}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--sunken">
        <div className="wrap">
          <div className="grid grid--2" style={{ gap: 48, alignItems: 'start' }}>
            <div>
              <span className="eyebrow">For developers</span>
              <h2>A documented API, with environments that stay apart</h2>
              <p style={{ color: 'var(--muted)' }}>
                Sandbox and production are separate environments with separate credentials, so a
                test integration cannot reach live customer data.
              </p>
              <ul className="ticks" style={{ marginTop: 20 }}>
                <li>REST API with per-tenant credentials and rate limits</li>
                <li>Outbound webhooks with retry and delivery history</li>
                <li>Idempotent writes, so a retried request cannot duplicate a record</li>
                <li>Audit history for every change an integration makes</li>
              </ul>
              <p style={{ marginTop: 24 }}>
                <a className="btn btn--ghost" href={endpoints.api}>
                  Open the API reference
                </a>
              </p>

              {/* Said plainly rather than discovered at a sign-in wall: the reference is
                  generated from a tenant's own metadata, so it cannot exist outside one. */}
              <p style={{ fontSize: '0.86rem', color: 'var(--muted)', marginTop: 12 }}>
                The reference lives inside your workspace, under Administration → Developer →
                REST API, and needs an account to open. Its object and field tables are generated
                from the same metadata the API serves, so they describe your configuration rather
                than a generic one.
              </p>
            </div>

            <div>
              <span className="eyebrow">Security</span>
              <h2>Tenant isolation is the first rule, not a setting</h2>
              <p style={{ color: 'var(--muted)' }}>
                Every business query is constrained by tenant and by the companies a user is
                authorised to see. It is enforced in the data layer, not left to each screen to
                remember.
              </p>
              <ul className="ticks" style={{ marginTop: 20 }}>
                <li>Role, profile, field-level and record-level permissions</li>
                <li>Encryption in transit and at rest</li>
                <li>Audit history, export and configurable retention</li>
                <li>Optional field encryption for sensitive HR and banking data</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
